module.exports = __webpack_public_path__ + "img/reciveOrder_active.a34d151d.png";